import { logoDevUrl, logoDomain } from '@parcel/types';

export { logoDomain };

export function logoUrl(domainOrUrl: string | null | undefined): string | null {
  return logoDevUrl(domainOrUrl, import.meta.env.VITE_LOGODEV_TOKEN);
}
